/* eslint-disable no-restricted-globals */
import { useMemo } from 'react';

import { US_STATES } from '../../constants/formOptions';
import useForm from '../utils/useForm';

const useLienHolderForm = (onSubmit, values, isEdit) => {
  /* const submitHandler = (formValues, actions) => {
    onSubmit(formValues);

    if (!values) {
      actions.resetForm();
    }
  }; */

  const fields = useMemo(
    () => [
      {
        title: isEdit ? 'Edit Lien Holder' : 'New Lien Holder',
        fields: [
          {
            title: 'Lien holder name',
            name: 'name',
            type: 'text',
            required: true,
          },
          {
            title: 'Address Line 1',
            name: 'address_line_1',
            type: 'text',
          },
          {
            title: 'Address Line 2',
            name: 'address_line_2',
            type: 'text',
          },
          {
            title: 'City',
            name: 'city',
            type: 'text',
          },
          {
            title: 'State',
            name: 'state',
            type: 'select',
            options: US_STATES,
          },
          {
            title: 'ZIP',
            name: 'zip',
            type: 'text',
            validation: 'zip',
          },
          {
            title: 'Email',
            name: 'email',
            type: 'text',
            validation: 'email',
          },
          {
            title: 'Phone',
            name: 'phone',
            type: 'text',
            validation: 'phone',
            mask: '(999) 999-9999',
          },
          {
            title: 'Wire instructions',
            name: 'wire_instructions',
            type: 'docUploader',
            className: 'col-span-full',
            multiple: false,
          },
        ],
      },
    ],
    [isEdit]
  );

  const { formik } = useForm({ fields, onSubmit, values });

  return { formik, fields, values };
};

export default useLienHolderForm;
